import * as React from 'react';
export const connectPaymentsSvg = React.forwardRef(
  function connectPaymentsSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M8.352 11.75a.75.75 0 0 1 .75-.75h3.27a.75.75 0 0 1 0 1.5h-3.27a.75.75 0 0 1-.75-.75ZM2.29 8.74a.75.75 0 0 1 .75-.75h1.68a.75.75 0 0 1 0 1.5H3.04a.75.75 0 0 1-.75-.75Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M1.75 1.5A1.75 1.75 0 0 0 0 3.25v7.5c0 .966.784 1.75 1.75 1.75h3.823a2.851 2.851 0 0 0 2.718 1.99h.99a.75.75 0 0 0 0-1.5h-.99a1.35 1.35 0 1 1 0-2.7h.99a.75.75 0 1 0 0-1.5h-.99A2.85 2.85 0 0 0 5.514 11H1.75a.25.25 0 0 1-.25-.25V6.01H13v2.78h-.82a.75.75 0 0 0 0 1.5h.99a1.35 1.35 0 1 1 0 2.7h-.99a.75.75 0 1 0 0 1.5h.99a2.85 2.85 0 0 0 1.33-5.37V3.25a1.75 1.75 0 0 0-1.75-1.75h-11ZM13 4.51V3.25a.25.25 0 0 0-.25-.25h-11a.25.25 0 0 0-.25.25v1.26H13Z',
      }),
    );
  },
);
connectPaymentsSvg.defaultProps = {
  width: '17',
  height: '16',
  viewBox: '0 0 17 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var connectPayments = {
  category: 'icon',
  colorable: true,
  name: 'connectPayments',
  svg: connectPaymentsSvg,
};
